import {
  Box,
  Breadcrumbs,
  Button,
  Card,
  CardActionArea,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  IconButton,
  InputAdornment,
  Paper,
  Slide,
  TextField,
  Tooltip,
  Typography,
} from '@mui/material';
import { useEffect, useState } from 'react';
import { withRouter } from 'react-router';
import { Link } from 'react-router-dom';
import { consultantRequestToFacility, getConsultantV2SearchFacilities } from '../../../helpers/api';
import { openNotification } from '../../../helpers/notification';
import { Empty } from 'antd';
import { ArrowBack, Close, Search } from '@mui/icons-material';
import LoaderSkeleton from '../../common/LoaderSkeleton';
import { EyeFilled } from '@ant-design/icons';

const JoinFacilityScreen = withRouter(({ history }) => {
  const searchParams = new URLSearchParams(history?.location?.search);
  const search = searchParams.get('search') || '';

  const screen = {
    all: 'all',
    selected: 'selected',
  };

  const [facilityList1, setFacilityList1] = useState([]);
  const [facilityList2, setFacilityList2] = useState([]);
  const [facilityLoading, setFacilityLoading] = useState(false);
  const [startSearch, setStartSearch] = useState(false);
  const [searchParam, setSearchParam] = useState('');
  const [refresh, setRefresh] = useState(false);
  const [facilitiesSelected, setFacilitiesSelected] = useState([]);
  const [dialogConfirmSubmit, setDialogConfirmSubmit] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [previewScreen, setPreviewScreen] = useState(screen.all);

  useEffect(() => {
    fetchFacilityList();
  }, []);

  useEffect(() => {
    setFacilityList2(facilityList1);
  }, [facilityList1]);

  useEffect(() => {
    handleSearchFacility(searchParam);
  }, [searchParam]);

  const handleSearchFacility = (value) => {
    const newParam = new URLSearchParams(searchParams);

    if (!value) {
      newParam.delete('search');
      history.push({ search: newParam.toString() });
      setFacilityList2(facilityList1);
    } else {
      newParam.set('search', value);
      history.push({ search: newParam.toString() });

      const filter = facilityList2?.filter((x) =>
        x?.facilityName?.toLowerCase().includes(value?.toLowerCase())
      );

      setFacilityList2(filter);
    }
  };

  const handleClearSearch = () => {
    const newParam = new URLSearchParams(searchParams);
    newParam.delete('search');
    history.push({ search: newParam.toString() });
    setSearchParam('');
  };

  const handleSelectDeselectFacility = (item) => {
    const exists = facilitiesSelected?.find((x) => x?.facilityId === item?.facilityId);
    if (exists) {
      const filtered = facilitiesSelected?.filter((x) => x?.facilityId !== item?.facilityId);
      setFacilitiesSelected(filtered);
    } else {
      setFacilitiesSelected((prev) => [...prev, item]);
    }
  };

  const handleSubmit = async () => {
    setSubmitting(true);
    try {
      const payload = facilitiesSelected?.map((i) => {
        return { facilityId: i?.facilityId, comment: '' };
      });

      const res = await consultantRequestToFacility(payload);
      const { data, status } = res?.result;
      if (status?.code === '00') {
        openNotification({ type: 'success', message: status?.desc });
        setDialogConfirmSubmit(false);
        handleClearSearch();
      }
    } catch (error) {
      console.log(error);
      const errmsg = error?.data?.result?.status?.desc;
      openNotification({ type: 'error', message: errmsg });
    } finally {
      setSubmitting(false);
    }
  };

  const fetchFacilityList = async () => {
    setFacilityLoading(true);
    try {
      const res = await getConsultantV2SearchFacilities();
      const { data, status } = res?.result;
      if (status?.code === '00') {
        setFacilityList1(data);
      } else {
        openNotification({
          type: 'error',
          message: status?.desc,
        });
      }
    } catch (error) {
      console.log(error);
      openNotification({
        type: 'error',
        message: 'Something went wrong',
      });
    } finally {
      setFacilityLoading(false);
    }
  };

  const handleRenderContent = () => {
    if (facilityLoading) {
      return (
        <Box mt={2}>
          <LoaderSkeleton />
          <br />
          <LoaderSkeleton />
        </Box>
      );
    } else {
      if (facilityList1?.length < 1) {
        return (
          <Box
            sx={{
              height: '70vh',
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              flexDirection: 'column',
            }}
          >
            <Empty />
            <br />
            <Typography>
              {`If you have not searched for a facility, please search for one to see result`}
            </Typography>
          </Box>
        );
      } else {
        return renderContent();
      }
    }
  };

  const renderContent = () => {
    if (previewScreen === screen.all) {
      return renderAllFacilities();
    } else if (previewScreen === screen.selected) {
      return renderSelectedFacilities();
    }
  };

  const renderAllFacilities = () => {
    return (
      <Box mt={2} sx={{ height: '70vh', overflowY: 'scroll' }}>
        {facilityList2?.map((i) => {
          const isSelected = !!facilitiesSelected?.find((x) => x?.facilityId === i?.facilityId);

          const category = i?.categoryName;
          let color;

          if (category === 'SUPER') color = 'error.main';
          if (category === 'LARGE') color = 'warning.main';
          if (category === 'MEDUIM') color = 'primary.main';
          if (category === 'SMALL') color = 'success.main';
          if (category === 'MINI') color = 'secondary.main';

          return (
            <Card
              elevation={0}
              sx={{
                boxShadow: `0px 1px 1px rgba(0, 0, 0, 0.1), 0px 2px 10px rgba(0, 0, 0, 0.15)`,
                border: 1,
                borderColor: 'divider',
                bgcolor: isSelected ? '#d0e9fa' : null,
                mb: 2,
              }}
            >
              <CardActionArea
                sx={{ display: 'flex', justifyContent: 'start' }}
                onClick={() => handleSelectDeselectFacility(i)}
              >
                <Box
                  sx={{
                    width: 100,
                    aspectRatio: '1/1',
                    bgcolor: color,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                  }}
                >
                  <Typography sx={{ color: '#FFFFFF' }}>{i?.categoryName}</Typography>
                </Box>
                <Box sx={{ display: 'flex', flexDirection: 'column', px: 2 }}>
                  <Typography component="div" variant="h6" mb={0.5}>
                    {i?.facilityName}
                  </Typography>
                  <Typography component="div" variant="body2" color="textSecondary">
                    {i?.address}
                  </Typography>
                  <Typography component="div" variant="body2" color="textSecondary">
                    {i?.stateName}
                  </Typography>
                </Box>
              </CardActionArea>
            </Card>
          );
        })}
      </Box>
    );
  };

  const renderSelectedFacilities = () => {
    return (
      <Slide direction="left" in={previewScreen === 'selected'} mountOnEnter unmountOnExit>
        <Box>
          <Box sx={{ mb: 2, display: 'flex', alignItems: 'center' }}>
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              <Tooltip title="Back">
                <IconButton onClick={() => setPreviewScreen(screen.all)}>
                  <ArrowBack />
                </IconButton>
              </Tooltip>
              <Box>
                <Typography fontWeight={600} color="textSecondary" variant="h6">
                  Selected Facilities
                </Typography>
              </Box>
            </Box>
            <Button
              variant="contained"
              color="primary"
              onClick={() => setDialogConfirmSubmit(true)}
              sx={{ textTransform: 'none', ml: 'auto' }}
            >
              Submit Selected
            </Button>
          </Box>
          <Box sx={{ height: '80vh', overflowY: 'scroll' }}>
            {facilitiesSelected?.map((i) => {
              const category = i?.categoryName;
              let color;

              if (category === 'SUPER') color = 'error.main';
              if (category === 'LARGE') color = 'warning.main';
              if (category === 'MEDUIM') color = 'primary.main';
              if (category === 'SMALL') color = 'success.main';
              if (category === 'MINI') color = 'secondary.main';

              return (
                <Card
                  elevation={0}
                  sx={{
                    boxShadow: `0px 1px 1px rgba(0, 0, 0, 0.1), 0px 2px 10px rgba(0, 0, 0, 0.15)`,
                    border: 1,
                    borderColor: 'divider',
                    bgcolor: '#d0e9fa',
                    mb: 2,
                  }}
                >
                  <CardActionArea
                    sx={{ display: 'flex', justifyContent: 'start' }}
                    onClick={() => handleSelectDeselectFacility(i)}
                  >
                    <Box
                      sx={{
                        width: 100,
                        aspectRatio: '1/1',
                        bgcolor: color,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                    >
                      <Typography sx={{ color: '#FFFFFF' }}>{i?.categoryName}</Typography>
                    </Box>
                    <Box sx={{ display: 'flex', flexDirection: 'column', px: 2 }}>
                      <Typography component="div" variant="h6" mb={0.5}>
                        {i?.facilityName}
                      </Typography>
                      <Typography component="div" variant="body2" color="textSecondary">
                        {i?.address}
                      </Typography>
                      <Typography component="div" variant="body2" color="textSecondary">
                        {i?.stateName}
                      </Typography>
                    </Box>
                  </CardActionArea>
                </Card>
              );
            })}
          </Box>
        </Box>
      </Slide>
    );
  };

  return (
    <Box px={3}>
      <Breadcrumbs sx={{ flexGrow: 1 }}>
        <Link to="/facilities">
          <Typography variant="body2" color="info.main">
            Facilities
          </Typography>
        </Link>
        <Typography variant="body2" color="text.primary">
          Join Facility
        </Typography>
      </Breadcrumbs>
      <Box
        px={3}
        py={3}
        sx={{
          margin: { lg: '0 12rem', md: '0 12rem', sm: '0rem', xs: '0rem' },
        }}
      >
        {previewScreen === screen.all && (
          <Box>
            <Box mb={2}>
              <TextField
                fullWidth
                value={searchParam}
                placeholder="Search for facility"
                onChange={(e) => setSearchParam(e.target.value)}
                slotProps={{
                  input: {
                    startAdornment: (
                      <InputAdornment position="start">
                        <Search />
                      </InputAdornment>
                    ),
                    endAdornment: (searchParam || search) && (
                      <InputAdornment position="end">
                        <IconButton onClick={handleClearSearch}>
                          <Close />
                        </IconButton>
                      </InputAdornment>
                    ),
                  },
                }}
              />
            </Box>

            {facilitiesSelected?.length > 0 && (
              <Box sx={{ display: 'flex', mb: 2 }}>
                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => setDialogConfirmSubmit(true)}
                  sx={{ textTransform: 'none' }}
                >
                  Submit Selected
                </Button>

                <Button
                  variant="text"
                  color="primary"
                  endIcon={<EyeFilled />}
                  onClick={() => setPreviewScreen('selected')}
                  sx={{ textTransform: 'none', ml: 'auto' }}
                >
                  {facilitiesSelected?.length} Selected
                </Button>
              </Box>
            )}
          </Box>
        )}
        {handleRenderContent()}
        {dialogConfirmSubmit && (
          <Dialog
            open={dialogConfirmSubmit}
            onClose={() => setDialogConfirmSubmit(false)}
            maxWidth="xs"
          >
            <Box sx={{ display: 'flex', alignItems: 'center' }}>
              {/* <DialogTitle variant="body1" sx={{ fontWeight: 600 }}>
              Edit Personnel
            </DialogTitle> */}
              <Box ml="auto" px={3} pt={1}>
                <IconButton onClick={() => setDialogConfirmSubmit(false)}>
                  <Close />
                </IconButton>
              </Box>
            </Box>
            <DialogContent sx={{}}>
              {`A request will be sent to the personnels of the failicty you selected.`}
            </DialogContent>
            <DialogActions sx={{ px: 2, pb: 3 }}>
              <Button
                type="button"
                variant="contained"
                color="info"
                disabled={submitting}
                startIcon={submitting && <CircularProgress size={20} />}
                sx={{ textTransform: 'none', borderRadius: 20 }}
                onClick={handleSubmit}
              >
                Submit Request
              </Button>
            </DialogActions>
          </Dialog>
        )}
      </Box>
    </Box>
  );
});

export default JoinFacilityScreen;
